module.exports = __webpack_public_path__ + "static/media/exp_anchorage_1.e550e84c.svg";